export const NO_PASSKEYS_REGISTERED_MESSAGE =
  'No passkey is set up for this account yet — you can add one in Account Settings after signing in.';

const GENERIC_PASSKEY_SIGN_IN_MESSAGE = 'Failed to sign in with passkey. Please try another method.';
const PASSKEY_CANCELLED_MESSAGE = 'Passkey authentication was cancelled.';

const collectErrorText = (error) => [
  error?.code,
  error?.message,
  error?.details,
  error?.cause?.code,
  error?.cause?.message,
]
  .filter(Boolean)
  .map((value) => String(value))
  .join(' ');

export function getPasskeySignInErrorMessage(error) {
  if (error?.name === 'NotAllowedError') {
    return PASSKEY_CANCELLED_MESSAGE;
  }

  const errorText = collectErrorText(error);
  if (/No passkeys are registered for this user/i.test(errorText)) {
    return NO_PASSKEYS_REGISTERED_MESSAGE;
  }

  return GENERIC_PASSKEY_SIGN_IN_MESSAGE;
}
